import { GlobalStyles as MuiGlobalStyles } from "@schaeffler-commerce/design-system";

// Migrated from CMSPageNavigation.less. Both selectors target markup the
// CMSPageNavigation component does not render itself:
// - the parent-container class is toggled at runtime via classList on the
//   surrounding page-template wrapper (outside the React tree), and
// - the anchored sections the navigation scrolls to (any section[id] inside a
//   .scha__cms wrapper) are owned by arbitrary CMS page content.
export const pageNavigationStyles = () => ({
  ".scha__cmspagenav__parent-container": {
    position: "sticky",
    top: "-1rem",
    zIndex: 2,
  },
  // Padding leaves room for the sticky navigation; without it, sections that
  // are too small would confuse the active-tab detection.
  ".scha__cms section[id]": {
    paddingTop: "5rem",
    "&:first-child": {
      paddingTop: 0,
    },
  },
});

export const PageNavigationGlobalStyles = () => <MuiGlobalStyles styles={pageNavigationStyles} />;
